module.exports = __webpack_public_path__ + "static/media/eyv.a125fa67.jpg";